(function(){var s=document.createElement("style");s.textContent=".wtg-term-link{color:inherit;text-decoration:none;border-bottom:1px dotted #C4A864;cursor:help}\n  .wtg-term-link:hover{color:#12302C;border-bottom-color:#12302C}";document.head.appendChild(s);})();
(function(){
  /* ===== 設定 ============================================================ */
  var PAGE = '/pages/watch-glossary';   // 用語集ページのURL（作成したページのハンドルに合わせる）
  var SELECTORS = [                      // 商品説明が入っている要素。テーマに合わせて追加可
    '.product__description', '.product-single__description', '.product__description.rte',
    '.product-single__content .rte', '[data-product-description]', '.product-form__description',
    '#ProductInfo-template--main .rte', '.product__accordion .rte'
  ].join(',');
  var MAX_LINKS = 14;                    // 1ページあたりの最大リンク数
  var MIN_LEN   = 3;                     // これより短い用語はリンクしない
  var SKIP = ['保証','相場','定価','買取','希少性','経年変化','保管','針','石','焼け','シミ','ガタ','サビ','ケース','文字盤','風防','素材','コマ','薄型','時針','分針','秒針','棚卸し','回転率','テーパー','キーパー','ステッチ','裏張り','ロゴ','防水','耐磁','希少','個体差','石数'];
  /* ====================================================================== */

  function esc(s){return s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');}
  function run(){
    var data = window.WT_GLOSSARY_INDEX; if(!data || !data.length) return;
    var roots = document.querySelectorAll(SELECTORS); if(!roots.length) return;
    var terms = data.slice()
                    .filter(function(s){return s.length>=MIN_LEN && SKIP.indexOf(s)<0;})
                    .sort(function(a,b){return b.length-a.length;});
    var used = {}, count = 0;
    Array.prototype.forEach.call(roots, function(root){
      if(root.getAttribute('data-wtg-done')) return;
      root.setAttribute('data-wtg-done','1');
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode:function(n){
          if(!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          var p = n.parentNode;
          while(p && p !== root){
            var tag = p.nodeName;
            if(tag==='A'||tag==='SCRIPT'||tag==='STYLE'||tag==='CODE'||tag==='BUTTON'||/^H[1-3]$/.test(tag)) return NodeFilter.FILTER_REJECT;
            p = p.parentNode;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var queue=[], n; while((n=walker.nextNode())) queue.push(n);
      while(queue.length && count < MAX_LINKS){
        var node = queue.shift();
        var avail = terms.filter(function(t){return !used[t];});
        if(!avail.length) break;
        var re = new RegExp(avail.map(esc).join('|'));
        var m = re.exec(node.nodeValue);
        if(!m) continue;
        var term = m[0];
        var after = node.splitText(m.index);
        after.nodeValue = after.nodeValue.slice(term.length);
        var a = document.createElement('a');
        a.className = 'wtg-term-link';
        a.href = PAGE + '?term=' + encodeURIComponent(term);
        a.title = term + ' の意味を見る';
        a.textContent = term;
        node.parentNode.insertBefore(a, after);
        used[term] = 1; count++;
        queue.unshift(after);
      }
    });
  }
  function boot(){ if(window.WT_GLOSSARY_INDEX){ run(); } else { setTimeout(boot,150); } }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load', function(){ setTimeout(run,60); });
})();
